import { Link, useParams } from "react-router-dom";
import { useFetch } from "@/hooks/useFetch";
import { useSeo } from "@/hooks/useSeo";
import { media } from "@/lib/api";
import { dateOnly } from "@/lib/format";
import { ProductGrid } from "@/components/store/ProductCard";

export default function Article() {
  const { slug } = useParams();
  const { data, loading, error } = useFetch(`/store/journal/${slug}`);
  useSeo(data?.title || null, data?.excerpt || null);
  if (loading && !data) return <div className="container-lux py-24"><p className="text-sm text-muted-foreground">Loading…</p></div>;
  if (error || !data) return <div className="container-lux py-24 text-center" data-testid="article-not-found"><p className="font-display text-4xl">Not found</p><Link to="/journal" className="btn-ink mt-8 inline-flex">Back to Journal</Link></div>;
  return (
    <article className="pb-20" data-testid="article-page">
      {data.hero_image_url && <div className="relative h-[60vh] min-h-[420px] bg-white overflow-hidden grain" data-testid="article-hero"><img src={media(data.hero_image_url, 2000)} alt="" className="absolute inset-0 w-full h-full object-cover" /></div>}
      <div className="container-lux">
        <div className="max-w-[760px] mx-auto">
          <nav className="text-xs text-muted-foreground mt-8 mb-6" data-testid="breadcrumbs"><Link to="/" className="hover:text-foreground">Home</Link><span className="mx-1.5">/</span><Link to="/journal" className="hover:text-foreground">Journal</Link><span className="mx-1.5">/</span><span className="text-foreground">{data.title}</span></nav>
          <p className="eyebrow">{data.category || "Editorial"}{data.is_demo ? " · Demo" : ""} · {dateOnly(data.published_at)}</p>
          <h1 className="font-display text-5xl sm:text-6xl font-medium mt-3 leading-[1.05]" data-testid="article-title">{data.title}</h1>
          {data.author && <p className="text-sm text-muted-foreground mt-6">By {data.author}</p>}
          <div className="prose prose-neutral max-w-none mt-10 text-[17px] leading-[1.75] whitespace-pre-line" data-testid="article-body">{data.body}</div>
        </div>
      </div>
      {data.products?.length > 0 && (
        <section className="container-lux mt-16 pt-10 border-t" data-testid="article-shop">
          <h2 className="font-display text-3xl mb-8">Shop the edit</h2>
          <ProductGrid items={data.products} testid="article-shop-grid" />
        </section>
      )}
    </article>
  );
}
